import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';

import { ToastAlertPosition } from '../ToastContext';

export const PositionStyles: Record<ToastAlertPosition, SxProps<Theme>> = {
  [ToastAlertPosition.topRight]: {
    top: 0,
    right: 0,
  },
  [ToastAlertPosition.topLeft]: {
    top: 0,
    left: 0,
  },
  [ToastAlertPosition.bottomRight]: {
    bottom: 0,
    right: '5.5rem',
  },
  [ToastAlertPosition.bottomLeft]: {
    left: 0,
    bottom: 0,
  },
};
